import React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Step as IStep } from "./BulkUpdate";

interface Steppers {
  steps: string[];
  activeStep: IStep;
}

const classes = {
  root: {
    margin: "0 auto",
    "& .MuiStepIcon-text": {
      fontWeight: "bold",
      fontSize: 13,
    },
    "& .MuiStepLabel-label": {
      fontSize: 14,
    },
    "& .MuiStepIcon-root": {
      width: 25,
      height: 25,
    },
  },
  stepper: {
    backgroundColor: "var(--dmg-gray-200)",
    borderRadius: 2,
    padding: 2,
  },
  connector: {
    fontSize: "1rem",
    fill: "var(--dmg-gray-400)",
    margin: "0 30px",
  },
};

export default function Steppers(props: Steppers) {
  const { activeStep, steps } = props;

  return (
    <Box p={1}>
      <Box flex={1} px={2} alignItems="center" display="flex">
        <h1>Bulk Update</h1>

        <Box sx={classes.root}>
          <Stepper
            activeStep={activeStep}
            sx={classes.stepper}
            connector={<ArrowForwardIosIcon sx={classes.connector} />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>
    </Box>
  );
}
